import React from "react";
import FilterRemoveIcon from "mdi-material-ui/FilterRemove";
import Button from "@civicplus/preamble-ui/lib/Button";
import Grid from "@civicplus/preamble-ui/lib/Grid";
import Typography from "@civicplus/preamble-ui/lib/Typography";
import { makeStyles } from "@civicplus/preamble-ui/lib/Utilities/ThemeHelper";
import { updateEventFilters } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../app/store";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  errorMessage: {
    marginTop: theme.spacing(4),
    textAlign: "center",
  },
}));

const NoEventMessage: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const eventFilters = useSelector((state: RootState) => state.eventFilters);

  const dispatch = useDispatch<AppDispatch>();

  const clearFilters = () => {
    dispatch(
      updateEventFilters({
        date: {
          from: null,
          to: null,
        },
        categories: [],
        contentTypes: [],
      })
    );
    if (eventFilters.search === "*" || eventFilters.search === "") {
      history.push(`/`);
    } else if (eventFilters.search) {
      history.push(`search?q=${eventFilters.search}`);
    }
  };

  const hasFilters =
    (eventFilters.categories && eventFilters.categories.length > 0) ||
    eventFilters.date?.to ||
    eventFilters.date?.from ||
    (eventFilters.contentTypes && eventFilters.contentTypes.length > 0);

  return (
    <Grid
      container={true}
      spacing={2}
      data-testid="noData"
      className={classes.errorMessage}
    >
      <Grid item={true} xs={12}>
        <Typography variant="h6" component="p">
          No events found
        </Typography>
      </Grid>
      {hasFilters ? (
        <>
          <Grid item={true} xs={12}>
            <Typography variant="subtitle1" component="p">
              Please change the date, your filters, or try different keywords
            </Typography>
          </Grid>
          <Grid item={true} xs={12}>
            <Button
              startIcon={<FilterRemoveIcon fontSize="small" />}
              color="secondary"
              onClick={clearFilters}
            >
              Clear all filters
            </Button>
          </Grid>
        </>
      ) : (
        <Grid item={true} xs={12}>
          <Typography variant="subtitle1" component="p">
            Please try a different keyword
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default NoEventMessage;
